<template>
  <div class="simulation">
    <div class="banner">
      <img src="../assets/simulation/banner.png" alt />
      <div class="simtitle">
        <img src="../assets/simulation/logo.png" alt />
        <span>仿真实训</span>
      </div>
    </div>
    <div class="videolist">
      <div class="left">
        <ul>
          <li v-if="navList.length == 0">暂无数据</li>
          <li
            v-else
            v-for="(item, index) in navList"
            :key="index"
            @click="changenav(index, item.softType, item.softTypeId)"
            :class="{ active: current == index }"
          >
            {{ item.softType }}
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="sort">
          <span>仿真实训</span>
          <span>|</span>
          <span>{{ sorttopic }}</span>
        </div>
        <div class="notbox" v-if="robotList.length == 0">
          <img class="notimg" src="../assets/blank/notlist.png" alt="" />
          <p class="inp">暂无内容</p>
        </div>
        <template v-else>
          <div class="videobox" v-for="item in robotList" :key="item.id">
            <div class="title">
              {{ item.softName }}
            </div>
            <div class="video">
              <img v-if="item.coverFrom == 0" :src="item.cover" alt="" />
              <template v-else>
                <div
                  :id="`myPlayer${item.id}`"
                  class="playbox"
                  style="height: 509px"
                >
                  <div
                    v-if="item.playAuth"
                    class="player"
                    style="width: 912px; height: 509px"
                  ></div>
                  <div class="notbox" v-else>
                    <img
                      class="notimg"
                      src="../assets/blank/notlist.png"
                      alt=""
                    />
                    <p class="inp">视频还在审核中</p>
                  </div>
                </div>
              </template>
            </div>
            <p class="detailabout" :title="item.about">{{ item.about }}</p>
            <div class="btnbox">
              <span @click="toDetail(item.id)">查看详情></span>
              <span @click="apply(item.id)">申请试用></span>
              <span @click="download(item.downloadUrl)">软件下载></span>
            </div>
          </div>
          <div class="page">
            <pagination
              :pagination="pagination"
              @changePage="changePage"
              :isChange="searchInfo.page"
            ></pagination>
          </div>
        </template>
      </div>
    </div>

    <a-modal
      title="申请试用"
      :visible="isapply"
      @ok="applyOk"
      @cancel="isapply = false"
      okText="提交"
      cancelText="取消"
      :destroyOnClose="true"
      class="isshowmodal"
    >
      <!-- <div>
        <p>详情请咨询：</p>
        <p>电话：027-87528232</p>
        <p>邮箱：market@gdcourse.com</p>
      </div> -->
      <p>请您如实填写下列信息，我们会尽快与您联系！</p>
      <eform title="申请试用" :formData="formData" class="formbox" ref="form">
        <div slot="name">
          <a-input
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorname },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的姓名"
          />
        </div>
        <div slot="address">
          <a-input
            v-decorator="[
              'address',
              {
                rules: [
                  { required: true, message: '' },
                  { validator: validatoraddress },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的单位"
          />
        </div>
        <div slot="job">
          <a-input
            v-decorator="[
              'job',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorjob },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的姓名"
          />
        </div>
        <div slot="phone">
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatorphone },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的手机号码"
          />
        </div>
        <div slot="email">
          <a-input
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: ' ' },
                  { validator: validatoremail },
                ],
              },
            ]"
            class="input"
            placeholder="请输入您的姓名"
          />
        </div>
        <div slot="content" class="conbox">
          <a-textarea
            class="applycon"
            placeholder="请输入您的重点需求"
            v-decorator="[
              'content',
              {
                rules: [
                  { required: true, message: '' },
                  { validator: validatorinfo },
                ],
              },
            ]"
          >
          </a-textarea>
        </div>
      </eform>
    </a-modal>
    <!-- 返回顶部按钮 -->
    <div class="gohead" v-show="flaghead">
      <a href="#layout"></a>
    </div>
  </div>
</template>

<script>
import "../../lib/aliyun-upload-sdk-1.5.0.min.js";
import "../../lib/aliyun-oss-sdk-5.3.1.min.js";
import eform from "@/components/common/form";
import {
  getisvideoApi,
  getsimulationlistApi,
  getcommitApplyApi,
  getsimulationsoftlistApi,
} from "@/request/api";
import pagination from "@/components/common/pagination";
export default {
  name: "simulation",
  components: { pagination, eform },
  data() {
    const formData = [
      {
        label: "姓名",
        scopedSlots: { customRender: "name" },
      },
      {
        label: "单位",
        scopedSlots: { customRender: "address" },
      },
      {
        label: "职务",
        scopedSlots: { customRender: "job" },
      },
      {
        label: "电话",
        scopedSlots: { customRender: "phone" },
      },
      {
        label: "邮箱",
        scopedSlots: { customRender: "email" },
      },
      {
        label: "描述",
        scopedSlots: { customRender: "content" },
      },
    ];
    let validatorname = (rule, value, callback) => {
      let reg = /^[\u4e00-\u9fa5]/;
      if (value == "" || reg.test(value)) {
        this.username = value;
        callback();
      } else {
        callback(new Error("请输入真实姓名"));
      }
    };
    let validatoraddress = (rule, value, callback) => {
      if (value.trim()) {
        if (value == "" || value) {
          this.useraddress = value;
          callback();
        } else {
          callback(new Error("请输入您的单位"));
        }
      } else {
        callback(new Error("请输入您的单位"));
      }
    };
    let validatorjob = (rule, value, callback) => {
      if (value.trim()) {
        if (value == "" || value) {
          this.job = value;
          callback();
        } else {
          callback(new Error("请输入您的职务"));
        }
      } else {
        callback(new Error("请输入您的职务"));
      }
    };
    let validatorinfo = (rule, value, callback) => {
      if (value.trim()) {
        if (value == "" || value) {
          this.userinfo = value;
          callback();
        } else {
          callback(new Error("请输入描述"));
        }
      } else {
        callback(new Error("请输入描述"));
      }
    };
    // let validatoremail = (rule, value, callback) => {
    //   if (value.trim()) {
    //     if (value == "" || value) {
    //       this.emial = value;
    //       callback();
    //     } else {
    //       callback(new Error("请输入合法邮箱"));
    //     }
    //   } else {
    //     callback(new Error("请输入邮箱"));
    //   }
    // };
    let validatoremail = (rule, value, callback) => {
      let reg = /^[\w]\w{0,20}@(qq.com|126.com|163.com|QQ.com)$/;
      if (value == "" || reg.test(value)) {
        this.email = value;
        callback();
      } else {
        callback(new Error("请输入合法邮箱"));
      }
    };
    let validatorphone = (rule, value, callback) => {
      var regphone = /^1[3456789]\d{9}$/;
      if (regphone.test(value)) {
        this.userphone = value;
        callback();
      } else {
        callback(new Error("请输入正确格式的手机号"));
      }
    };
    return {
      formData,
      validatorphone,
      validatoraddress,
      validatorname,
      validatorinfo,
      validatoremail,
      validatorjob,
      job: "",
      email: "",
      username: "",
      userinfo: "",
      userphone: "",
      useraddress: "",
      navList: [],
      current: 0,
      flaghead: false,
      searchInfo: {
        page: 1,
        pageSize: 4,
        softTypeId: "",
      },
      pagination: { total: "", pageSize: 4 },
      isshow: true,
      isexit: false,
      isapply: false,
      sorttopic: " ",
      isPlay: false,
      PlayAuth: "",
      videoUrl: "",
      videoId: "",
      coverUrl: "",
      resourceUrl: "",
      player: "",
      robotList: [],
      productId: "",
    };
  },
  created() {
    if (this.$route.query.page) {
      this.searchInfo.page = this.$Base64.decode(this.$route.query.page);
    }

    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
  },
  methods: {
    init() {
      this.getToken(getsimulationsoftlistApi, {}, (res) => {
        this.navList = res.data.map((item) => item);
        this.searchInfo.softTypeId = res.data[0].softTypeId;
        this.sorttopic = res.data[0].softType;
        this.simList();
      });
    },
    simList() {
      this.getToken(getsimulationlistApi, this.searchInfo, (res) => {
        this.robotList = res.data.rows.map((item) => ({
          ...item,
          playAuth: "",
        }));
        // console.log('数据是',this.robotList)
        this.pagination.total = res.data.count;

        this.robotList.forEach((item) => {
          if (item.coverFrom == 1) {
            this.towatch(item.cover, item.id);
          }
        });
      });
    },
    towatch(vid, id) {
      this.getToken(getisvideoApi, { videoId: vid }, (res) => {
        if (res.code == 200) {
          let PlayAuth = res.data.PlayAuth;
          // this.PlayAuth = res.data.PlayAuth;
          this.robotList.filter((item) => item.id == id)[0].playAuth =
            res.data.PlayAuth;
          let coverUrl = res.data.VideoMeta.CoverURL;
          // console.log(coverUrl)
          // console.log(id)
          this.player = new Aliplayer(
            {
              id: `myPlayer${id}`, //播放器外层容器的dom元素id
              vid: vid, //视频id
              playauth: PlayAuth, // 播放凭证
              width: "100%", //样式
              height: "514px", //样式
              autoplay: false, // 自动播放
              isLive: false, // 直播
              cover: coverUrl, //播放器默认封面图片,需要autoplay为’false’时，才生效
              rePlay: false, // 循环播放
              playsinline: true, //H5是否内置播放
              preload: false, //播放器自动加载
              language: "zh-cn",
              controlBarVisibility: "always", //控制面板的实现‘click’ 点击出现、‘hover’ 浮动出现、‘always’ 一直在
              useH5Prism: true, //指定使用H5播放器
              encryptType: 1,
            },
            function () {
              // console.log("playAuth:",that.playAuth);
              //  player.replayByVidAndPlayAuth(that.resourceUrl,that.PlayAuth)
              console.log("创建成功了");
            }
          );
          console.log("播放器是", this.player);
        }
      });
    },
    //导航
    changenav(index, item, softTypeId) {
      this.current = index;
      this.sorttopic = item;
      this.searchInfo.softTypeId = softTypeId;
      this.searchInfo.page = 1;
      this.simList();
    },
    //分页
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.simList();
    },
    //查看详情
    toDetail(id) {
      this.$router.push({
        path: "/simulationDetail",
        query: {
          id: this.$Base64.encode(id),
          page: this.$Base64.encode(this.searchInfo.page),
        },
        // this.$Base64.encode(this.searchInfo.page)
      });
    },
    //申请试用
    apply(id) {
      this.isapply = true;
      this.productId = id;
      // console.log(this.productId)
    },
    applyOk() {
      if (this.username) {
        if (this.useraddress) {
          if (this.job) {
            if (this.userphone) {
              if (this.email) {
                if (this.userinfo) {
                  this.$refs.form.form.validateFields().then((res) => {
                    console.log(res);
                    this.getToken(
                      getcommitApplyApi,
                      {
                        productId: this.productId,
                        user: res.name,
                        institute: res.address,
                        telephone: res.phone,
                        info: res.content,
                        title:res.job,
                        email:res.email
                      },
                      (val) => {
                        if (val.code == 200) {
                          this.$message.success("申请成功");
                          this.isapply = false;
                        }
                      }
                    );
                  });
                } else {
                  this.$message.error("请输入描述信息");
                }
              } else {
                this.$message.error("请输入邮箱");
              }
            } else {
              this.$message.error("请输入联系方式");
            }
          } else {
            this.$message.error("请输入职务");
          }
        } else {
          this.$message.error("请输入单位信息");
        }
      } else {
        this.$message.error("请输入用户姓名");
      }
    },
    applycancel() {
      this.isapply = false;
    },
    //软件下载
    download(url) {
      this.$confirm({
        title: "请访问如下网址进行下载:",
        okText: "知道了",
        content: url,
        cancelText: "取消",
        onOk() {
          console.log("OK");
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    //返回顶部
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 100) {
        this.flaghead = true;
      } else {
        this.flaghead = false;
      }
    },
  },
};
</script>
<style lang="stylus">
.isshowmodal {
  p {
    color: #000;
    text-align: center;
    font-size: 16px;
  }
}

.formbox textarea.ant-input {
  margin-bottom: 4px;
  min-height: 200px;
}

.formbox .ant-form-item-label label {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
}

.isshowmodal .ant-modal-title {
  margin: 0;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
  font-size: 20px;
  line-height: 22px;
}

.isshowmodal .ant-modal-close-x {
  color: #666;
  font-size: 25px;
}
</style>
<style lang="stylus" scoped>
.simulation {
  overflow: hidden;

  .banner {
    height: 100px;
    margin: 0 auto;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .simtitle {
      width: 1205px;
      position: absolute;
      display: flex;
      align-items: center;
      padding-left: 40px;
      font-weight: 600;
      left: 50%;
      bottom: 23px;
      transform: translateX(-50%);
      z-index: 555;

      img {
        width: 46px;
        height: 46px;
      }

      span {
        font-size: 22px;
        color: #fff;
        margin-left: 11px;
      }
    }
  }

  .videolist {
    width: 1205px;
    margin: 40px auto;
    display: flex;

    .left {
      width: 220px;

      ul {
        width: 100%;

        li {
          height: 50px;
          line-height: 50px;
          text-align: center;
          border: 1px solid #d5d5d5;
          font-size: 16px;
          color: #333;
          margin-bottom: 15px;
          cursor: pointer;
        }

        .active {
          background: #f1ce48;
        }
      }
    }

    .right {
      margin-left: 62px;
      flex: 1;

      .sort {
        margin-bottom: 5px;
        border-bottom: solid 1px #e5e5e5;

        span:nth-child(1) {
          color: #f1ce48;
          font-size: 16px;
          margin-right: 5px;
        }

        span:nth-child(2) {
          margin-right: 5px;
          margin-left: 5px;
          color: #000;
        }

        span:nth-child(3) {
          color: #333333;
          font-size: 16px;
        }
      }

      .notbox {
        margin: 0 auto;
        margin-bottom: 30px;
        margin-top: 40px;
        text-align: center;
        min-height: 455px;

        img {
          display: block;
          margin: 0 auto;
        }

        .inp {
          font-size: 18px;
          color: #666;
          margin: 0 auto;
          text-align: center;
          margin-top: 10px;
        }
      }

      .videobox {
        border-bottom: solid 1px #c1c1c1;

        .title {
          font-weight: bold;
          height: 75px;
          line-height: 75px;
          font-size: 20px;
          colr: #333;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-wrap: nowrap;
        }

        .video {
          border: 5px solid #eee;
          width: 922px;
          height: 519px;
          margin-bottom: 25px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }

          .playbox {
            height: 509px;

            .player {
              width: 912px;
              height: 500px;
            }

            .notbox {
              width: 912px;
              height: 509px;
              margin: 0 auto;
              text-align: center;

              .notimg {
                display: block;
                margin: 0 auto;
                width: 600px;
                height: 400px;
              }

              .inp {
                font-size: 18px;
                color: #666;
                margin: 0 auto;
                text-align: center;
                margin-top: 10px;
              }
            }
          }
        }

        .detailabout {
          width: 920px;
          color: #333333;
          font-size: 16px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          word-wrap: break-word;
          word-break: normal;
        }

        .btnbox {
          display: flex;
          position: relative;
          height: 60px;

          span {
            width: 128px;
            height: 32px;
            background-color: #f0cd48;
            font-size: 14px;
            color: #333;
            text-align: center;
            display: blcok;
            line-height: 32px;
            cursor: pointer;
          }

          span:nth-child(3) {
            position: absolute;
            right: 0;
          }

          span:nth-child(2) {
            position: absolute;
            right: 138px;
          }

          span:nth-child(1) {
            position: absolute;
            right: 276px;
          }
        }
      }
    }
  }
}

.page {
  padding-bottom: 10px;
  padding-top: 30px;
}

.gohead {
  width: 66px;
  height: 58px;
  background-color: #f9f9fa;
  border-radius: 3px;
  border: solid 1px #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 240px;
  bottom: 50px;
  cursor: pointer;

  a {
    width: 33px;
    height: 32px;
    display: inline;
    text-align: center;
    background: url('../assets/home/gohead3.png') -18px -15px no-repeat;
  }
}

.gohead:hover {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}

.gohead:active {
  a {
    background: url('../assets/home/gohead4.png') -18px -15px no-repeat;
  }
}
</style>
